import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
    title: ReactNode;
};

const TooltipInfo = ({ title }: Props) => (
    <Tooltip title={title}>
        <InfoIcon color="primary" />
    </Tooltip>
);

export default TooltipInfo;
